import React, {useEffect, useRef, useState} from 'react';
import {useLocation, useParams} from 'react-router-dom';
import Helmet from 'react-helmet';
import axios from 'axios';
import OpenApp from './../components/OpenApp';
import {getUseParams, setUrl} from '../utils/baseUtil';
import {setWeixinData} from '../utils/wxShareUtil';
import Avatar from '../components/qa/Avatar'

let lastTime = 0;
let totalList = [];
const Proficient = () => {
  const location = useLocation();
  let params = useParams();

  const query = getUseParams(location.search);
  const [childCate, setChildCate] = useState([]);
  const [cate, setCate] = useState([]);
  const [activeChildCate, setActiveChildCate] = useState({});
  const [list, setList] = useState([]);
  const [hasMore, setHasMore] = useState(false);

  const loadingRef = useRef(false);
  const loadingDivRef = useRef(null);
  const intersectionObserver = useRef(null);

  useEffect(() => {
    console.log('9099',location)
    if (!!params.id) {
      getData()
    }
  }, [params.id]);

  useEffect(() => {
    if (hasMore) {
      intersectionObserver.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          getList();
        }
      }, {
        root: null,
        rootMargin: '0px 0px 100px 0px',
        threshold: 0
      });

      intersectionObserver.current.observe(loadingDivRef.current);
    }
    return () => {
      if (intersectionObserver.current) {
        intersectionObserver.current.unobserve(loadingDivRef.current);
        intersectionObserver.current.disconnect();
        intersectionObserver.current = null;
      }
    };
  }, [hasMore]);

  useEffect(() => {
    if (!!activeChildCate.id) {
      getList()
    }
  }, [activeChildCate.id]);

  const getData = () => {
    axios.get('/api2/proficient/info/more', {
      timeout: 5000,
      params: {
        inid: Number(params.id),
        os: 'web',
        sv: query.sv || '8.3.4'
      },
    }).then((response) => {
      if (response && response.data && response.data.code === 0 && response.data.data) {
        const data = response.data.data;
        if (!!data.input_indus) {
          if (typeof setWeixinData !== 'undefined') {
            setWeixinData((data.input_indus.industry || '') + '领域专家', '', data.share_logo || '');
          }
          if (Array.isArray(data.child_cate)) {
            setChildCate(data.child_cate);
            if (data.experts_of_level === 1) {
              setCate([data.input_indus]);
            }
          } else {
            setCate([data.input_indus]);
          }
          if (data.experts_of_level === 1) {
            setActiveChildCate(data.input_indus || {});
          } else {
            if (Array.isArray(data.child_cate) && !!data.child_cate.length) {
              setActiveChildCate(data.child_cate[0]);
            }
          }
        }
      }
    }).catch((error) => {
    });
  };

  const getList = () => {
    if (loadingRef.current) {
      return;
    }
    loadingRef.current = true;
    axios.get('/api2/proficient/info/list', {
      timeout: 5000,
      params: {
        inid: activeChildCate.id,
        lastTime: lastTime,
        limit: 20,
        type: 3,
        os: 'web',
        direct: 1,
        sv: query.sv || '8.3.4',
      },
    }).then((response) => {
      loadingRef.current = false;
      if (response && response.data && response.data.code === 0 && response.data.data) {
        const data = response.data.data;
        let resultList = data.list;
        if (Array.isArray(resultList) && resultList.length > 0) {
          setHasMore(resultList.length >= 20);
          totalList = !lastTime ? resultList : totalList.concat(resultList);
          setList(totalList);
        } else {
          setHasMore(false);
          if (!lastTime) {
            totalList = '没有相关内容';
            setList(totalList);
          }
        }
        lastTime = Array.isArray(totalList) && totalList.length > 0 ? (totalList[totalList.length - 1].create_time || 0) : 0;
      }
    }).catch((error) => {
      loadingRef.current = false;
    });
  };

  const handleGetChildCate = (item) => {
    lastTime = 0;
    setActiveChildCate(item);
  };

  return (
    <>
    <Helmet>
      <body className="bg-c-0f1214ffffff s-body proficient-body"/>
      <title>{activeChildCate.industry || '专家'}</title>
      <link rel="stylesheet" href={`${process.env.REACT_APP_OSS_HOST}/css/841/proficient_841.css`}/>
    </Helmet>
    <OpenApp openUrl={!!params.id ? `lanjing://proficient_list?detail_id=${params.id}` : ''}/>
    <div className="p-r o-h proficient-box">
      {
        Array.isArray(childCate) && !!childCate.length &&
        <div className="p-a proficient-menu-box">
          {
            cate.concat(childCate).map(item => {
              return (
                <div key={item.id}
                     className={`d-f f-c-c w-100p ${item.id === activeChildCate.id ? 'f-s-14 c-fff bg-c-339aff-84bfff' : 'f-s-13 c-565f71'} proficient-menu`}
                     onClick={() => handleGetChildCate(item, 0)}>
                  {item.industry}
                </div>
              )
            })
          }
        </div>
      }
      <div className={`h-100p o-a ${Array.isArray(childCate) && !!childCate.length ? 'proficient-list-box' : ''}`}>
        {
          (Array.isArray(list) && list.length > 0) ?
            <div>
              {
                list.map(item => {
                  return (
                    <div key={item.id} className="b-c-e8e8f3 proficient-list" >
                      <a className="d-b m-b-11" href={setUrl('/resources/html/qa_proficient.html', query, item.id)}>
                        <Avatar
                          type="proficient"
                          size="small"
                          item={{
                            head_img: item.head_img,
                            real_name: item.name,
                            tid: item.id,
                            company_name: item.company,
                            position: item.position,
                            city: item.city
                          }}
                          nofollow={true}
                        />
                      </a>
                      {!!item.des && <div className="m-b-11 o-h f-s-15 l-h-115385 c-191c27 t-o-el w-s-n">{item.des}</div>}
                      {
                        Array.isArray(item.industry) && !!item.industry.length &&
                        <div className="d-f f-s-s o-h f-s-12 l-h-166667 proficient-list-tag-box">
                          <div className="f-s-0 c-9ea5bb proficient-list-tag-title">擅长</div>
                          <div className="clearfix">
                            {
                              item.industry.map((tagValue) => {
                                return <div key={tagValue.id} className="f-l c-565f71 bg-c-203051f5f6fa proficient-list-tag">{tagValue.industry}</div>
                              })
                            }
                          </div>
                        </div>
                      }
                    </div>
                  )
                })
              }
            </div> : <div className="d-f f-d-c f-c-c l-h-157143 f-s-14 c-9395a2 lanjing-empty-box">
              <div className="m-b-12 lanjing-empty-box-icon">
                <img className="w-100p h-100p o-f-c" src="https://file.jingpt.com/wap/images/square-empty-white.png" alt=""/>
              </div>
              <div className="t-a-c">该分类下暂无专家入驻</div>
            </div>
        }
        <div ref={loadingDivRef} className="m-b-12 t-a-c c-9ea5bb proficient-list-tips">
          {(Array.isArray(list) && list.length > 0) ? hasMore ? '加载中...' :
            <>
              <div className="d-f f-c-c m-b-11">
                <svg width="16" height="20" viewBox="0 0 16 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
                  <path className="f-9ea5bb" d="M15.5,0 L15.5,1.5 C15.2238576,1.5 15,1.72385763 15,2 L15,18 C15,19.1045695 14.1045695,20 13,20 L0.5,20 L0.5,18.5 C0.77614237,18.5 1,18.2761424 1,18 L1,2 C1,0.8954305 1.8954305,0 3,0 L15.5,0 Z M13.5630137,1.49998077 L3,1.5 C2.72385763,1.5 2.5,1.72385763 2.5,2 L2.5,18 C2.5,18.1730179 2.47803011,18.3409045 2.43672788,18.5010222 L13,18.5 C13.2761424,18.5 13.5,18.2761424 13.5,18 L13.5,2 C13.5,1.82734329 13.5218783,1.65979652 13.5630137,1.49998077 Z M9,13 L9,14 L4,14 L4,13 L9,13 Z M12,9 L12,10 L4,10 L4,9 L12,9 Z M12,5 L12,6 L4,6 L4,5 L12,5 Z"/>
                </svg>
              </div>
              <div className="f-s-12 l-h-133333 t-s-91667">～看到底啦～</div>
            </> : ''}
        </div>
      </div>
    </div>
    </>
  );
};

export default Proficient;